'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$46() {
  this.bDT = null;
  this.bDU = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$46 as $c_Lpresto_TwoFactorAuthView$$anon$46 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$46;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$46() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$46 as $h_Lpresto_TwoFactorAuthView$$anon$46 };
$h_Lpresto_TwoFactorAuthView$$anon$46.prototype = $p;
$p.P = (function() {
  if ((!this.bDU)) {
    this.bDT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bDU = true;
  }
  return this.bDT;
});
var $d_Lpresto_TwoFactorAuthView$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$46, "presto.TwoFactorAuthView$$anon$46", ({
  SJ: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$46 as $d_Lpresto_TwoFactorAuthView$$anon$46 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$46.js.map
